import { render, staticRenderFns } from "./Transact112.vue?vue&type=template&id=d4f1a24a&scoped=true"
import script from "./Transact112.vue?vue&type=script&lang=js"
export * from "./Transact112.vue?vue&type=script&lang=js"
import style0 from "./Transact112.vue?vue&type=style&index=0&id=d4f1a24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f1a24a",
  null
  
)

export default component.exports